import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import FleetManagementApiService from './FleetManagementApiService'
import { GET_FLEET_AFE_CHANGE_LOG, GET_FLEET_ASSET_CHANGE_LOG } from '../../Store/FleetManagement/FleetAssetChangeLog/FleetAssetChangeLogType'
import { setFleetAfeChangeLog, setFleetAssetChangeLog } from '../../Store/FleetManagement/FleetAssetChangeLog/FleetAssetChangeLogAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* fleetAssetChangeLogSaga(req: any): any {
  try {
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/transdisporeactivationchangelogs/${req.fleetRequestDetailId}`,
      apiMethod :  apiMethod.GET,
      payload : null
    }
    const response = yield call(
      FleetManagementApiService.post, API_URL.PostWebApp, payloadData   
    );
    const fleetAssetChangeLog = yield select(
      (state: any) => state.FleetAssetChangeLogReducer.fleetAssetChangeLog,
    );
    let fleetAssetChangeLogTemp = []
    if (response?.length) {
      if (fleetAssetChangeLog?.length) {
        fleetAssetChangeLogTemp = fleetAssetChangeLog?.filter((filterItem?: any) => filterItem?.id != req?.fleetRequestDetailId)
      }
      const result = {
        id: req.fleetRequestDetailId,
        response: response,
      };
      fleetAssetChangeLogTemp?.push(result)
      yield put(setFleetAssetChangeLog(fleetAssetChangeLogTemp));
    } else {
      yield put(setFleetAssetChangeLog([]));
    }
  } catch (error: any) {
    yield put(setFleetAssetChangeLog([]));
  }
}

function* fleetAfeChangeLogSaga(req: any): any {
  try {
    let payloadData : IPayload = {
      apiType : apiType.FleetManagement,
      endpoint : `fleet/afechangelogs/${req.fleetRequestDetailId}`,
      apiMethod :  apiMethod.GET,
      payload : null
    }
    const response = yield call(
      FleetManagementApiService.post, API_URL.PostWebApp, payloadData   
    );
    const fleetAfeChangeLog = yield select(
      (state: any) => state.FleetAssetChangeLogReducer.fleetAfeChangeLog,
    );
    let fleetAfeChangeLogTemp = []
    if (response?.length) {
      if (fleetAfeChangeLog?.length) {
        fleetAfeChangeLogTemp = fleetAfeChangeLog?.filter((filterItem?: any) => filterItem?.id != req?.fleetRequestDetailId)
      }
      const result = {
        id: req.fleetRequestDetailId,
        response: response,
      };
      fleetAfeChangeLogTemp?.push(result)
      yield put(setFleetAfeChangeLog(fleetAfeChangeLogTemp));
    } else {
      yield put(setFleetAfeChangeLog([]));
    }
  } catch (error: any) {
    yield put(setFleetAfeChangeLog([]));
  }
}

function* watchGetFleetDispositionSave() {
  yield takeEvery(GET_FLEET_ASSET_CHANGE_LOG, fleetAssetChangeLogSaga)
  yield takeEvery(GET_FLEET_AFE_CHANGE_LOG, fleetAfeChangeLogSaga)
}

export default function* combinedSaga() {
  yield all([
    watchGetFleetDispositionSave()
  ])
}
